import React from "react";

export const pricingContent = {
  badge: {
    text: "Flexible Pricing",
  },
  headingBefore: "Choose your perfect ",
  headingAccent: "plan",
  /** @deprecated Use headingBefore + headingAccent */
  heading: "Choose your perfect plan",
  /** Subtitle is built in Pricing.jsx via buildPricingDescriptionText (trial_days from site config). */
  descriptionIncludesTrial: true,
  toggle: {
    monthly: "Monthly",
    annual: "Annual",
    savings: "Save 20%",
  },
  additionalInfo: {
    linkText: "View Full Pricing Details",
    linkHref: "/pricing",
  },
};

export const plans = [
  {
    name: "Basic",
    description: "For small consultancies just getting started",
    monthlyPrice: 999,
    annualPrice: 799,
    features: [
      "Access to job listings",
      "Basic search filters",
      "Up to 300 Job Fetching per month",
      "Support Only 1 user",
      "CSV exports",
      "Email support",
    ],
    popular: false,
    icon: (
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
  {
    name: "Professional",
    description: "For growing consultancies with multiple users",
    monthlyPrice: 2499,
    annualPrice: 1999,
    features: [
      "Everything in Basic",
      "Resume Generator",
      "Advanced search filters",
      "Up to 750 Job Fetching per month",
      "Support up to 3 users",
      "CSV exports",
      "Priority email support",
    ],
    popular: true,
    icon: (
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 10V3L4 14h7v7l9-11h-7z"
        />
      </svg>
    ),
  },
  {
    name: "Enterprise",
    description: "For large consultancies with high volume needs",
    monthlyPrice: 4999,
    annualPrice: 3999,
    features: [
      "Everything in Professional",
      "Custom filters",
      "Up to 2,000 Job Fetching per month",
      "Support up to 20 users",
      "All export formats",
      "Dedicated Account Manager",
      "Advanced analytics",
      "Candidate Email Alert",
    ],
    popular: false,
    icon: (
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        />
      </svg>
    ),
  },
];
